
import Echo from "laravel-echo"
window.Pusher = require('pusher-js');

// get a unique token for the identification of users which are not logged in
let token = localStorage.getItem('guest_token');
if (!token) {
    token = Math.random().toString(36).substr(2);
    localStorage.setItem('guest_token', token);
}

window.Echo = new Echo({
    broadcaster: 'pusher',
    key: "2d6c03a9e712fbbf8af7",
    cluster: "eu",
    forceTLS: true,
    authEndpoint : process.env.VUE_APP_API_ENDPOINT + '/api/broadcasting/auth',
    auth:{
        headers: {
            "Guest-Token": token, 
        }
    },
});